import { useCallback, useContext, useEffect, useMemo } from 'react';
import { ChatStateDispatchContext } from '@trinity/chat-components/components/Chat.State/context';
import { ChatQueryStatus, SocketNamespace } from '@trinity/chat';
import { QuerySocketEvent } from '@trinity/chat';
import { useChatQuerySocket } from '@trinity/chat-components/websocket';
import type { WS } from '@trinity/chat';
import { createLogger } from '@trinity/chat-components/websocket/utils';

type Props = {
  children: React.ReactNode;
  queryIdentifier: string;
  queryStatus: ChatQueryStatus;
};

export const QueryFollowupsContainer = (props: Props) => {

  const logger = useMemo(() => createLogger({
    namespace: SocketNamespace.Queries,
  }), []);

  const enabled = useMemo(() => {
    const result = props.queryStatus === ChatQueryStatus.Complete;
    logger.log(`[FollowupsContainer] enabled check — queryStatus: ${props.queryStatus}, enabled: ${result}`);
    return result;
  }, [props.queryStatus, logger]);

  const dispatch = useContext(ChatStateDispatchContext);
  const socket = useChatQuerySocket(props.queryIdentifier, enabled);

  const handleFollowupsAvailable = useCallback((data: WS.QueryFollowupsAvailable.Data) => {
    logger.log(`[FollowupsContainer] received ${QuerySocketEvent.QueryFollowupsAvailable}`);
    dispatch({
      type: 'query-followups-available',
      payload: {
        queryIdentifier: data.queryIdentifier,
        items: data.items,
      },
    });
  }, [dispatch, logger]);

  useEffect(() => {
    logger.log(`[FollowupsContainer] socket effect — socket: ${socket ? 'connected' : 'null'}, enabled: ${enabled}, queryIdentifier: ${props.queryIdentifier}`);
    if (!socket) return;

    logger.log(`[FollowupsContainer] registering listener for ${QuerySocketEvent.QueryFollowupsAvailable}`);
    socket.on(QuerySocketEvent.QueryFollowupsAvailable, handleFollowupsAvailable);

    return () => {
      logger.log(`[FollowupsContainer] removing listener for ${QuerySocketEvent.QueryFollowupsAvailable}`);
      socket.off(QuerySocketEvent.QueryFollowupsAvailable, handleFollowupsAvailable);
    };
  }, [handleFollowupsAvailable, socket, enabled, props.queryIdentifier, logger]);

  return (
    <>
      {props.children}
    </>
  );
};